import { useLoaderData } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { loader as contentLoader } from './loader'
import { DesktopView } from './views/desktop'
import { MobileView } from './views/mobile'
import { useConsumerBranding } from '~/portal/hooks/useConsumerBranding'
import appDefaults from '~/portal/portal.defaults.json'
import { PortalRouteHandle } from '~/portal/types/app'
import { LayoutType } from '~/portal/types/layout'
import { ErrorBoundaryComponent } from '~/shared/components/ErrorBoundary'

export const loader = contentLoader

export const handle: PortalRouteHandle = {
  layout: {
    [LayoutType.DEFAULT]: {
      consumerTopBar: {
        search: {
          disabled: false
        }
      },
      previewTopBar: {
        productContent: {
          disabled: true
        }
      }
    }
  },
  breadcrumb: ({ match }) =>
    match.loaderData?.currentProduct?.name
}

export default function DocsLayout() {
  const { sections } = useLoaderData<typeof contentLoader>()

  const branding = useConsumerBranding()

  const { items } = sections
  const tableOfContents = items[0]?.tableOfContents || []

  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })

  return (
    
    isMobile ? <MobileView
      tableOfContents={tableOfContents}
      branding={branding}
    /> :
      <DesktopView
        tableOfContents={tableOfContents}
        branding={branding}
      />
  )
}

export const ErrorBoundary = ErrorBoundaryComponent